import React, { Component } from 'react';
import 'ant-design-pro/dist/ant-design-pro.css';
import Crumbs from './../Crumbs/Crumbs';//面包屑
import { Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, AutoComplete, Modal, message, Alert,Popover,Progress  } from 'antd';

import EventSet from "./../../../assets/PubJs/hcPub"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import "./UserInfo.css"
import $ from "jquery"
import createHistory from 'history/createHashHistory'

const history = createHistory();
const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;

var time = "";
var time1 = "";

let base = new EventSet.Base64();

//个人信息安全信息
let _UserInfoForm = null;
class UserInfoForm extends React.Component {
    state = {
        autoCompleteResult: [],
        visible: false
    };

    //性别选择
    handleSelectChange = (value) => {

    }

    componentDidMount() {
        _UserInfoForm = this;
        this.props.form.setFieldsValue({
            user: JSON.parse(localStorage.getItem("userInfo")).loginName
        })
    }

    //密码修改弹窗确定
    handleOk = (e) => {
        console.log('44',_PasswordRevise.state.visible)
   
        _PasswordRevise.props.form.validateFields((err, values) => {
            if (!err) {
                _PasswordRevise.setState({
                    visible:false
                })
                $.ajax({
                    url: Hcurl + "/user/UpdatePassword",
                    type: "post",
                    headers: {
                    "token": EventSet.getUserInfo()['token']
                    },
                    asunc: false,
                    data: {
                        passWord: _PasswordRevise.props.form.getFieldValue("username"),
                        newPassWord: _PasswordRevise.props.form.getFieldValue("password"),
                        CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
                    },
                    headers: {
                        token: JSON.parse(localStorage.getItem("userInfo")).token
                    },
                    success: function (res) {
                        var data = res
                        if(data.indexOf('false')>-1){
                            _PasswordRevise.setState({
                                visible:false
                            })
                            message.warn(data.split('|')[1])
                          }else{
                            message.success("密码修改成功");
                            sessionStorage.setItem('pwdInfo', 'true');
                            _UserInfoForm.props.form.setFieldsValue({
                                password: _PasswordRevise.props.form.getFieldValue("password")
                            })
                            _PasswordRevise.setState({
                                confirmDirty: false,
                                visible:false
                            })
                            //弹窗消失
                            _UserInfoForm.setState({
                                visible: false,
                            });
                            setTimeout(()=>{
                                history.push({ pathname: '/Login/LoginMain/LoginEntry'})
                            },800)
                          }

                        
                    },
                    error: function () {
                        history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    }
                })
            }else{
                _PasswordRevise.setState({
                    visible:false
                })
            }
        })
    }
    //密码修改弹窗取消
    handleCancel = (e) => {
        _PasswordRevise.setState({
            confirmDirty: false,
            visible: false,
        })
        this.setState({
            visible: false,
            
        });
    }

    //联系电话点击修改
    telRevise = () => {
        _App.setState({
            visible: true,
            modelTitel: <div  style={{ fontSize: "14px", color: "#333" }}>手机号码修改： <span>安全验证</span></div>,
            stepTitle:'下一步 1/2'
        })

        setTimeout(function () {

            _NewPhoneRevise.props.form.resetFields();

            window.clearInterval(time1);

            _NewPhoneRevise.setState({
                captcha: "获取验证码",
                captDisable: false,
                oldPhone:_App.state.oldPhone,
                show:true,
            })

            _NewPhoneRevise.props.form.setFieldsValue({
                oldPhonerevise:_App.Desensitization(_App.state.oldPhone,3,-4)
            })
        }, 100)
    }

    //密码点击修改
    passwordRevise = () => {
        _UserInfoForm.setState({
            visible: true,
            modelTitel: "密码修改"
        })
        
        setTimeout(function () {
            _PasswordRevise.props.form.resetFields();
        },100)
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { autoCompleteResult } = this.state;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 19 },
            },
        };

        const websiteOptions = autoCompleteResult.map(website => (
            <AutoCompleteOption key={website}>{website}</AutoCompleteOption>
        ));

        return (
            <Form style={{ marginTop:40 }}>
                <div style={{ fontSize: "20px" }}>个人信息</div>
                <FormItem
                    {...formItemLayout}
                    label="用户名"
                >
                    {getFieldDecorator('user', {
                        rules: [{
                            required: false, message: '',
                        }],
                    })(
                        <Input disabled />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="姓名"
                >
                    {getFieldDecorator('userName', {
                        rules: [{
                            required: true, message: '请输入姓名!',
                        }],
                    })(
                        <Input maxLength="20" placeholder="请输入姓名" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="性别"
                >

                    {getFieldDecorator('sex', {
                        rules: [{
                            required: false, message: '',
                        }], initialValue: "保密"
                    })(
                        <Select onChange={this.handleSelectChange}>
                        <Option value="保密">保密</Option>
                            <Option value="男">男</Option>
                            <Option value="女">女</Option>
                        </Select>
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="身份称谓"
                >
                    {getFieldDecorator('identity', {
                        rules: [{
                            required: false, message: '',
                        }],
                    })(
                        <Input maxLength="50" placeholder="请输入身份称谓" />
                        )}
                </FormItem>
                <div style={{ fontSize: "20px" }}>安全信息</div>
                <FormItem
                    {...formItemLayout}
                    label="联系电话"
                >
                    <Row gutter={12}>
                        <Col span={18}>
                            {getFieldDecorator('telphone', {
                                rules: [{ required: false, message: '' }],
                            })(
                                <Input disabled />
                                )}
                        </Col>
                        <Col span={6}>
                            <Button onClick={this.telRevise}>修改</Button>
                        </Col>
                    </Row>
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="密码">
                    <Row gutter={12}>
                        <Col span={18}>
                            {getFieldDecorator('password', {
                                rules: [{ required: false, message: '' }],
                            })(
                                <Input type="password" disabled />
                                )}
                        </Col>
                        <Col span={6}>
                            <Button onClick={this.passwordRevise}>修改</Button>
                        </Col>
                    </Row>
                </FormItem>
                <Modal
                    title="密码修改"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okText="确定"
                    cancelText="取消"
                    maskClosable={false}
                >
                    <PasswordModal />
                </Modal>
            </Form>
        );
    }
}

const WrapperUserInfoForm = Form.create()(UserInfoForm);




//修改手机号点击下一步之后的弹窗
let _NewPhoneRevise = null;
class NewPhoneRevise extends React.Component {
    state = {
        captcha: "获取验证码",
        captDisable: false,
        loading: false,
        phoneExist: false,
        phoneFormat:false,
        show:true,
    };

    componentDidMount() {
        _NewPhoneRevise = this;
    }

    //修改手机号下一步的获取验证码
    getCaptcha = () => {
        var type = 3
        if(_App.state.stepTitle.indexOf('下一步')>-1){
            type =3
        }else{
            type =5
        }
        if(type==3){
             //发送验证码
             $.ajax({
                url: Hcurl + "/HomePage/SendComPhoneValidCode",
                type: "POST",
                headers: {
                    token: JSON.parse(localStorage.getItem("userInfo")).token
                },
                data: {
                    Type: type,
                    UserCode:JSON.parse(localStorage.getItem("userInfo")).CU_Code,
                },
                async: false,
                success: function (res) {
                    if (res.indexOf("true") >= 0) {
                        message.success('验证码发送成功');
                      

                        _NewPhoneRevise.setState({
                            captcha: "60s",
                            captDisable: "true"
                        }, () => {
                            var timer = 60;
                            time1 = setInterval(function () {
                                timer--;
                                _NewPhoneRevise.setState({
                                    captcha: timer + "s"
                                }, () => {
                                    if (timer == 0) {
                                        window.clearInterval(time1);
                                        time1 = "";
                                        _NewPhoneRevise.setState({
                                            captcha: "获取验证码",
                                            captDisable: false
                                        })
                                    }
                                })
                            }, 1000)
                        })
                    } else {
                        message.error("验证码发送失败");
                    }
                }
            })
        }else{
            $.ajax({
                url: Hcurl + "/HomePage/SendValidCode?phone=" + _NewPhoneRevise.props.form.getFieldValue('newPhonerevise')+"&type=5",
                type: "get",
      
                async: false,
                success: function (res) {
                  console.log(res)
                      if (res.indexOf("true") >= 0) {
                        message.success("验证码发送成功");
                        _NewPhoneRevise.setState({
                            captcha: "60s",
                            captDisable: "true"
                        }, () => {
                            var timer = 60;
                            time1 = setInterval(function () {
                                timer--;
                                _NewPhoneRevise.setState({
                                    captcha: timer + "s"
                                }, () => {
                                    if (timer == 0) {
                                        window.clearInterval(time1);
                                        time1 = "";
                                        _NewPhoneRevise.setState({
                                            captcha: "获取验证码",
                                            captDisable: ""
                                        })
                                    }
                                })
                            }, 1000)
                        })
                    }else{
                        message.error("验证码发送失败");
                    }
                }})
        }
           
        
    }
 

 

    //验证手机号是否存在
    phoneTest = (e) => {
        if (_NewPhoneRevise.props.form.getFieldValue("newPhonerevise") != "" && _NewPhoneRevise.props.form.getFieldValue("newPhonerevise") != undefined) {
            if (!this.state.phoneFormat) {
                let getData = {
                    Phone: e.target.value
                }
                $.ajax({
                    url: Hcurl + "/user/IsExistLinkPhoneWithUser",
                    type: "post",
                    data: {
                        linkPhone: e.target.value,
                        CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
                    },
                    headers: {
                        token: JSON.parse(localStorage.getItem("userInfo")).token
                    },
                    async: false,
                    success: function (res) {
                        //手机号是否注册
                        if (res.indexOf("false") >= 0) {
                            _NewPhoneRevise.setState({
                                phoneExist: true,
                                captDisable:true,
                                alertShow: <Alert style={{width:'91%',marginLeft:'28px',marginBottom:'20px'}} message="手机号码已被注册" type="error" showIcon  />
                            })

                        } else {
                            _NewPhoneRevise.setState({
                                alertShow: "",
                                phoneExist: false,
                                captDisable:false,
                            })
                        }
                    },
                    error: function () {
                        // history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                    }
                })
     
            }
        }
    }

  

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 24,
                    offset: 0,
                },
            },
        };
        return (
            <Form style={{ width: 500, margin: "0 auto" }}>
                {this.state.alertShow}
                {this.state.show?<div>
                <FormItem
                {...formItemLayout}
                label="原手机号"
                >
                    {getFieldDecorator('oldPhonerevise', {
                        rules: [{
                            required: true, message: '请输入手机号码!'
                        }],
                    })(
                        <Input disabled placeholder="11位手机号" maxLength="11" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="验证码"
                >
                    <Row gutter={8}>
                        <Col span={16}>
                            {getFieldDecorator('newcaptcha', {
                                rules: [{ required: true, message: '请输入验证码!' }],
                            })(
                                <Input placeholder="输入验证码" maxLength={6} />
                                )}
                        </Col>
                        <Col span={8}>
                            <Button onClick={this.getCaptcha} disabled={this.state.captDisable} style={{ width: "105px" }}>{this.state.captcha}</Button>
                        </Col>
                    </Row>
                </FormItem>
                </div>:''}
               
                {!this.state.show?<div>
                <FormItem
                {...formItemLayout}
                label="新手机号"
                >
                    {getFieldDecorator('newPhonerevise', {
                        rules: [{
                            required: true, message: '请输入手机号码!'
                        },{ pattern: /^1[0-9]{10}$/, message: '手机号格式错误！' }],
                    })(
                        <Input onChange={this.phoneTest}  placeholder="请输入手机号码" maxLength="11" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="验证码"
                >
                    <Row gutter={8}>
                        <Col span={16}>
                            {getFieldDecorator('newcaptcha', {
                                rules: [{ required: true, message: '请输入验证码!' }],
                            })(
                                <Input placeholder="输入验证码" maxLength={6} />
                                )}
                        </Col>
                        <Col span={8}>
                            <Button onClick={this.getCaptcha} disabled={this.state.captDisable} style={{ width: "105px" }}>{this.state.captcha}</Button>
                        </Col>
                    </Row>
                </FormItem>
                </div>:''}
                
            </Form>
        );
    }
}

const PhoneRevise = Form.create()(NewPhoneRevise);


//点击修改密码的弹窗
let _PasswordRevise = null;
class PasswordRevise extends React.Component {
    state = {
        confirmDirty: false,
        visible:false,
        level:'弱',
        proColor:'#f5222d',
        source:10,
        sourceText:'8-16位，须同时包含字母、数字、符号，区分大小写，请不要使用容易被猜到的密码。'
    };

    componentDidMount() {
        _PasswordRevise = this;
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    }
    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('两次输入的密码不一致。');
        } else {
            callback();
        }
    }
    validateToNextPassword = (rule, value, callback) => {
        let _this = this
        if (!value) {
            callback()
            _PasswordRevise.setState({
                visible:false,
            })
        }
        else if (/^.*[\u4E00-\u9FA5].*$/.test(value)) {
            callback('密码中不可包含中文')
        }
        else {
            _PasswordRevise.setState({
                visible:false,
            })
            if (value.indexOf(' ') > -1) {
                callback('密码中不可包含空格');
            }
            // else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)(?![0-9a-zA-Z]+$)(?![0-9\W]+$)(?![a-zA-Z\W]+$)[0-9A-Za-z\W]{8,16}$/.test(value)) {
            else if (!/^(?![0-9]+$)(?![a-zA-Z]+$)(?![\W]+$)(?![0-9a-zA-Z]+$)(?![0-9a-z\W]+$)(?![0-9\W]+$)(?![a-zA-Z\W]+$)[0-9A-Za-z\W]{8,16}$/.test(value)) {
                callback('8-16位，须同时包含字母、数字、符号，区分大小写');
            }
            else {
               
                if (EventSet.returnScore(value) < 60) {
                    callback('密码太简单了，请重新设置。');
                }
                else if (sessionStorage.getItem('codeData') && sessionStorage.getItem('codeData').split('臡').indexOf(value) > -1) {
                    callback('密码太简单了，请重新设置。');
                    _PasswordRevise.setState({
                        proColor:'#f5222d',
                        level:'弱',
                        source:33
                        })
                }
                else {
                    console.log('598')
                    _PasswordRevise.setState({
                        visible:true,
                    })
                    if(EventSet.returnScore(value)<60){
                        _PasswordRevise.setState({
                            proColor:'#f5222d',
                            level:'弱',
                            source:33
                        })
                    }else if (EventSet.returnScore(value)>59&&EventSet.returnScore(value)<80){
                        _PasswordRevise.setState({
                            proColor:'orange',
                            level:'中',
                            source:66
                        })
                    }else{
                        _PasswordRevise.setState({
                            proColor:'#52c41a',
                            level:'强',
                            source:99
                        })
                    }
                    callback();
                }
            }
        }
    }

    //keyup = () => {
    //    _PasswordRevise.props.form.setFieldsValue({
    //        password: _PasswordRevise.props.form.getFieldValue("password").replace(/\s+/g, '')
    //    })
    //}
    blur=()=>{
        _PasswordRevise.setState({
            visible:false,
        })
      }

    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 18 },
            },
        };
        return (
            <Form style={{ width: 500, margin: "0 auto" }}>
                <FormItem
                    {...formItemLayout}
                    label="原密码"
                >
                    {getFieldDecorator('username', {
                        rules: [{
                            required: true, message: '请输入原密码！',
                        }, {
                            validator: this.userTest,
                        }],
                    })(
                        <Input maxLength="20" type="password" placeholder="请输入原密码" />
                        )}
                </FormItem>
                <Popover
                            placement="rightTop"
                            content={<div style={{width:'290px',padding:'10px 10px'}}>
                                <p style={{color:this.state.proColor,marginBottom:'0'}}>强度：{this.state.level}</p>
                                <Progress strokeColor={this.state.proColor} percent={this.state.source} showInfo={false} />
                                <p style={{marginBottom:'0'}}>{this.state.sourceText}</p>
                            </div>}
                            title="密码强度"
                            trigger="click"
                            visible={this.state.visible}
                        >
                <div></div>
                </Popover>
                <FormItem
                    {...formItemLayout}
                    label="新密码"
                >
                    {getFieldDecorator('password', {
                        rules: [{
                            required: true, message: '请输入密码！',
                        }, { validator: this.validateToNextPassword }],
                    })(
                        <Input onBlur={this.blur} type="password" placeholder="8-16位，须同时包含字母、数字、符号，区分大小写" maxLength="16" />
                        )}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label="确认密码"
                >
                    {getFieldDecorator('confirm', {
                        rules: [{
                            required: true, message: '请确认密码！',
                        }, {
                            validator: this.compareToFirstPassword,
                        }],
                    })(
                        <Input type="password" onBlur={this.handleConfirmBlur} placeholder="再次输入新密码，两次密码需要一致" maxLength="16" />
                        )}
                </FormItem>
            </Form>
        );
    }
}

const PasswordModal = Form.create()(PasswordRevise);

let _App = null
class App extends Component {
    state = {
        visible: false,
        modelTitel: <div style={{ fontSize: "14px", color: "#333" }}>手机号码修改： <span >安全验证</span></div>,
        hei: 500,
        loading:false,
        stepTitle:'下一步 1/2',
        oldPhone:''
    }

    windowChangeSize() {
        let H = window.innerHeight - 229;
        this.setState({
            hei: H
        })
    }

    componentDidMount() {
        _App = this;
        this.windowChangeSize()

        //个人信息赋值
        $.ajax({
            url: Hcurl + "/user/GetUserInfo",
            type: "post",
            headers: {
            "token": EventSet.getUserInfo()['token']
            },
            data: {
                CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code
            },
            headers: {
                token: JSON.parse(localStorage.getItem("userInfo")).token
            },
            async: false,
            success: function (res) {
                //密码和手机号
                _UserInfoForm.props.form.setFieldsValue({
                    telphone: JSON.parse(res).linkPhone,
                    password: "123456",
                    sex: JSON.parse(res).sex,
                    userName: JSON.parse(res).userName,
                    identity: JSON.parse(res).CU_Title
                })
                _App.setState({
                    oldPhone:JSON.parse(res).linkPhone,
                })
            },
            error: function (res) {
                history.push({ pathname: '/Login/LoginMain/LoginEntry', })
            }
        })
    }
    Desensitization=(str,beginLen,endLen)=> {
        var len = str.length;
        var firstStr = str.substr(0,beginLen);
        var lastStr = str.substr(endLen);
        var middleStr = str.substring(beginLen, len-Math.abs(endLen)).replace(/[\s\S]/ig, '*');
        var  tempStr = firstStr + middleStr + lastStr;
        return tempStr;
    }
    //弹窗点击确定
    // handleOk = (e) => {
    //     _App.setState({
    //         visible: false,
    //     });
    // }
    //弹窗点击取消
    handleCancel = (e) => {
        //清除定时器
        window.clearInterval(time1);
        time1 = "";

        _App.setState({
            visible: false,
        });
        _NewPhoneRevise.setState({
            alertShow: ""
        })
    }

    //返回
    return = () => {
        window.history.back(-1);
    }

    //保存个人信息
    saveInfo = () => {
        _UserInfoForm.props.form.validateFields((err, values) => {
            if (!err) {
                _App.setState({
                    loading: true
                })

                setTimeout(function () {
                    $.ajax({
                        url: Hcurl + "/user/UpdateUserBaseInfo",
                        type: "post",
                    headers: {
                    "token": EventSet.getUserInfo()['token']
                    },
                        data: {
                            CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code,
                            sex: _UserInfoForm.props.form.getFieldValue("sex"),
                            userName: _UserInfoForm.props.form.getFieldValue("userName"),
                            CU_Title: _UserInfoForm.props.form.getFieldValue("identity")
                        },
                        headers: {
                            token: JSON.parse(localStorage.getItem("userInfo")).token
                        },
                        async: false,
                        success: function (res) {
                            _App.setState({
                                loading: false
                            })
                            if (res.indexOf(false) >= 0) {
                                message.warn("保存失败")
                            } else {
                                message.success("保存成功")
                                location.reload()
                            }
                        },
                        error: function () {
                            history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
                        }
                    })
                }, 100)
            }
        })
    }
    handleOk=()=>{
        let _this =this
        _NewPhoneRevise.props.form.validateFields((err, values) => {
            if (!err) {
                if(_this.state.stepTitle.indexOf('下一步')>-1){
                    let postData = {
                        UserCode: JSON.parse(localStorage.getItem("userInfo")).CU_Code,
                        Code: _NewPhoneRevise.props.form.getFieldValue("newcaptcha"),
                        type:3
                    }
                    $.ajax({
                        url: Hcurl + "/HomePage/CheckValidCode",
                        type: "post",
                        data:postData,
                        headers: {
                            token: JSON.parse(localStorage.getItem("userInfo")).token
                        },
                        async: false,
                        success: function (res) {
                           console.log(res)
                            if (res.indexOf('false')>-1) {
                                message.warn(res.split('|')[1]);
                            } else {
                                _this.setState({
                                    stepTitle:'提交 2/2',
                                    // safeCode:data.Info,
                                    modelTitel: <div style={{ fontSize: "14px", color: "#333" }}>手机号码修改： <span >确认新手机</span></div>,
                                })
                                _NewPhoneRevise.setState({
                                    show:false,
                                    captcha: "获取验证码",
                                    captDisable: false
                                })
                                _NewPhoneRevise.props.form.resetFields()
                                window.clearInterval(time1);
                            }
                        },
                        error: function () {
                            
                        }
                    })
                    console.log('1149',data)
                   
                }else{
                    let postData = {
                        linkPhone: _NewPhoneRevise.props.form.getFieldValue("newPhonerevise"),
                        validCode: _NewPhoneRevise.props.form.getFieldValue("newcaptcha"),
                        CU_Code: JSON.parse(localStorage.getItem("userInfo")).CU_Code,
                    }
                    $.ajax({
                        url: Hcurl + "/User/UpdateUserLinkPhone",
                        type: "post",
                        data:postData,
                        headers: {
                            token: JSON.parse(localStorage.getItem("userInfo")).token
                        },
                        async: false,
                        success: function (res) {
                           console.log(res)
                            if (res.indexOf('false')>-1) {
                                message.warn(res.split('|')[1]);
                                _NewPhoneRevise.setState({
                                    captcha: "获取验证码",
                                    captDisable: false
                                })
                                window.clearInterval(time1);
                            } else {
                                message.success(res.split('|')[1]);
                                _App.setState({
                                    visible:false
                                })
                                _UserInfoForm.props.form.setFieldsValue({
                                    telphone: _App.Desensitization(_NewPhoneRevise.props.form.getFieldValue("newPhonerevise"),3,-4)
                                })
                                setTimeout(() => {
                                    window.location.reload()
                                }, 200);
                            }
                        },
                        error: function () {
                            
                        }
                    })
                   
                    
                }
            }
        })
        
    }
    render() {
        return (
            <div id="UserInfo" style={{ background: "#f0f2f5" }}>
                <Crumbs title={"个人设置"} />
                <div className={"content UserInfoWrap"} style={{ minHeight: this.state.hei}} >
                    <div className="C_warp clear">
                        <div style={{ width: "400px", margin: "0 auto" }}>
                            <WrapperUserInfoForm />
                            <Row>
                                <Col span={24} style={{ textAlign: 'center' }}>
                                    <Button type="primary" htmlType="submit" onClick={this.saveInfo} loading={this.state.loading}>保存</Button>
                                    <Button style={{ marginLeft: 8 }} onClick={this.return}>返回</Button>
                                </Col>
                            </Row>
                            <Modal
                                title={this.state.modelTitel}
                                visible={this.state.visible}
                                onCancel={this.handleCancel}
                                footer={[<Button onClick={this.handleCancel}>取消</Button>,<Button onClick={this.handleOk} type="primary">{this.state.stepTitle}</Button>]}
                                maskClosable={false}
                            >
                                <PhoneRevise />
                            </Modal>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default App



// WEBPACK FOOTER //
// ./src/components/Content/UserInfo/UserInfo.js